import { cloneElement, useEffect, useState } from 'react';
import { TaxPayer } from '../../../constants';
import { TaxFilter } from '../../../models/Filters';
import { filterService } from '../../../services/filters';

export default function RootCategoryTaxFilterWrapper(props: any) {
  const { rootCategory, topLevelCategoryId } = props;
  const [taxList, setTaxList] = useState<TaxFilter[] | undefined>(undefined);
  const [employerTaxList, setEmployerTaxList] = useState<
    TaxFilter[] | undefined
  >(undefined);

  useEffect(() => {
    setTaxList(undefined);
    setEmployerTaxList(undefined);
    (async () => {
      const result =
        await filterService.getTaxFilterForCategory(topLevelCategoryId);
      if (!result.hasErrors) {
        const employerTaxes = result.data.filter(
          t => t.payer === TaxPayer.Employer,
        );
        const emplyeeTaxes = result.data.filter(
          t => t.payer === TaxPayer.Employee,
        );
        setTaxList(emplyeeTaxes);
        setEmployerTaxList(employerTaxes);
      }
    })();
  }, [topLevelCategoryId]);

  return cloneElement(props.children, {
    taxList,
    employerTaxList,
    rootCategory,
    topLevelCategoryId,
  });
}
